var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Send",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.158865921,1.85985859 C-0.108182698,1.38202197 -0.0332622567,0.786017075 0.343741637,0.389140701 C0.72074553,-0.00773567366 1.31211969,-0.113146836 1.80303259,0.129025252 L17.6480326,8.17819192 C17.857662,8.28481329 17.9896898,8.50008892 17.9896898,8.73527525 C17.9896898,8.97046158 17.857662,9.18573721 17.6480326,9.29235859 L1.80303259,17.3523586 C1.31211969,17.5945307 0.72074553,17.4891195 0.343741637,17.0922431 C-0.0332622567,16.6953668 -0.108182698,16.0993619 0.158865921,15.6215253 L4.37386592,8.73485859 L0.158865921,1.85985859 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9896993,
    y1: 8.73485859,
    x2: 4.36969925,
    y2: 8.73485859,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.abbd54bcf404fce4eac124f14979672d.svg";
export { ForwardRef as ReactComponent };